import { render, staticRenderFns } from "./NewsletterCard.vue?vue&type=template&id=36abe15d&scoped=true"
import script from "./NewsletterCard.vue?vue&type=script&lang=js"
export * from "./NewsletterCard.vue?vue&type=script&lang=js"
import style0 from "./NewsletterCard.vue?vue&type=style&index=0&id=36abe15d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36abe15d",
  null
  
)

export default component.exports